var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBalcony(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.56 19.349H4.44c-.596 0-1.08-.362-1.08-.81v-5.395c0-.149.161-.27.36-.27h16.56c.199 0 .36.121.36.27v5.396c0 .447-.484.809-1.08.809z",
    stroke: "#666",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.38 12.875H7.62v-6.87c0-.624.37-1.13.825-1.13h7.11c.455 0 .825.506.825 1.13v6.87z",
    stroke: "#666"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.24 12.958v6.25M9.12 12.958v6.25M12 12.958v6.25M14.88 12.958v6.25M17.76 12.958v6.25"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }))));
}
export default SvgBalcony;